<template>
  <b-card no-body class="shadow-lg rounded" border-variant="primary">
    <div slot="header">
      <strong>Select Device</strong>
    </div>
      <b-card-body>
        <b-row>
          <b-col sm="5">
            <b-form-group
            label="Search on Device code or uuid"
            label-cols-sm="5"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            >
              <b-input-group size="sm">
                <b-form-input
                  ref="focus"
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="code or uuid"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group
              label="Per page"
              label-cols-sm="4"
              label-align-sm="right"
              label-size="sm"
              label-for="perPageSelect"
            >
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
                :plain="true"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-button class="pull-right" variant="primary" size="md" :to="`/devicegroup/device/${deviceGroupId}/new`">New Device</b-button>
          </b-col>
        </b-row> 
        <b-table
          striped
          :current-page="currentPage"
          :per-page="perPage"
          :items="provider"
          :fields="fields"
          :filter="filter"
          @filtered="onFiltered"
          :filter-included-fields="filterOn"
          selectable
          select-mode="single"
          @row-selected="onSelectedRow"
          >
            <template v-slot:cell(actions)="row">
              <b-button size="sm" variant="primary" @click="onDelete(row.item.id)" append><i class="fa fa-trash"></i> Delete</b-button>
            </template>
          </b-table>
        <b-row>
          <b-col sm=4></b-col>
          <b-col>
            <b-pagination
                v-if="pagination"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
          </b-col>
          <b-col sm=4></b-col>
        </b-row>
      </b-card-body>
      <div class="px-4 py-2" style="background-color: #f0f3f5">
      <span>
        <strong>Company Devices</strong>
      </span>
    </div>
      <b-card-body>
        <b-table
          striped
          :current-page="currentPage"
          :per-page="perPage"
          :items="provider"
          :fields="fields"
          :filter="filter"
          @filtered="onFiltered"
          :filter-included-fields="filterOn"
          selectable
          select-mode="single"
          @row-selected="onSelectedRow"
          >
            <template v-slot:cell(actions)="row">
              <b-button size="sm" variant="primary" @click="onDelete(row.item.id)" append><i class="fa fa-trash"></i> Delete</b-button>
            </template>
          </b-table>
        <b-row>
          <b-col sm=4></b-col>
          <b-col>
            <b-pagination
                v-if="pagination"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
          </b-col>
          <b-col sm=4></b-col>
        </b-row>
      </b-card-body>

    </b-card>
</template>
<script>
import {mapActions } from "vuex"
import ViewExtension from '../../ViewExtension'

export default ViewExtension.extend({
    name: 'DeviceSelect',
    props: {
      deviceGroupId:{
        type: String,
        require: false,
      }
    },
    components: {
    },
    data() {
        return {
            fields: [
              {key: 'code', label:'Code', sortable: true},
              {key: 'uuid', label:'Uuid', sortable: true},
              {key: 'name', label:'Name', sortable: true},
              {key: 'status', label:'Status', sortable: true},
              {key: 'group', label:'Group Id', sortable: true},
              // {key: 'isOwner', label:'Owner Company', sortable: true},
              // {key: 'actions', label:'Actions'},
              ],
            filter: null, 
            filterOn: ["code","name"],
            pageOptions: [5,10,25,50],
            currentPage: 1,
            perPage: 10,
            sortedBy: 'id',
            sortedDesc: true,
            totalRows: 0,
            context: null,
            unassigned_deviced: null,
        }
    },
    computed: {
      pagination(){
        return this.totalRows > this.perPage
      },
    },
    methods: {
        ...mapActions("meds2go/device", ['filterDevices', 'getCompanyDevices']),
        async loadData(){
          if(this.deviceGroupId){
            this.loading()
            await this.getCompanyDevices(this.deviceGroupId).then(results => {
              console.log('provider: ', results.items)
              this.unassigned_deviced = results.items
            })
            this.stopLoading()
          }

        },
        provider(ctx, callback){
            this.filterDevices({context: this.context,
            page: ctx.currentPage,
            per_page: ctx.perPage,
            sort_by: ctx.sortBy,
            sort_desc: ctx.sortDesc,
            }).then(results => {
              console.log('provider: ',results.items)
              callback(results.items)
            this.totalRows = results.tot_rows
          })
        },
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length
          this.currentPage = 1
        },
        onSelectedRow(device){
          this.$emit('device', device[0])
        },
        onReset(){
        },
        onChange(){
        },
    },
    mounted() {
      this.loadData()
    }
})
</script>
